import script from "./UnderConstructionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UnderConstructionPage.vue?vue&type=script&setup=true&lang=js"

import "./UnderConstructionPage.vue?vue&type=style&index=0&id=aee10e32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aee10e32"]])

export default __exports__